import PropTypes from 'prop-types';
import React from "react";
import { apiGet } from "../../store/apiWrapper";
import { isNullOrUndefined } from "../../store/storeFunctions";

class DownloadFileButton extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        link: PropTypes.string,
        asButton: PropTypes.bool
    };

    static defaultProps = {
        string: 'downLnk',
        link: undefined,
        asButton: false
    };

    state = {
        webUrl: null
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isNullOrUndefined(prevState.webUrl) && prevState.webUrl !== this.state.webUrl) {
            window.URL.revokeObjectURL(prevState.webUrl);
        }
    }

    componentWillUnmount() {
        if (this.state.webUrl) {
            window.URL.revokeObjectURL(this.state.webUrl);
        }
    }

    render() {
        const { link, asButton } = this.props;
        return (
            <>
                {link && <a download href="#" style={{ display: 'none' }} id={`downLnk-${link}`}>D</a>}
                {asButton ? this.renderButton() : this.renderLink()}
            </>
        )
    }

    renderLink = () => {
        const { id, link, asButton, onClick, children, ...rest } = this.props;
        return (
            <a {...rest} id={id} onClick={() => { this.downloadFile(link); if (onClick) { onClick(); } }}>
                {children}
            </a>
        )
    }

    renderButton = () => {
        const { id, link, asButton, onClick, children, ...rest } = this.props;
        return (
            <button type="button" {...rest} id={id} onClick={() => { this.downloadFile(link); if (onClick) { onClick(); } }}>
                {children}
            </button>
        );
    }

    downloadFile(link) {
        if (!isNullOrUndefined(link)) {
            apiGet(link, null,
                (response) => {
                    var downloadLink = document.getElementById(`downLnk-${link}`);

                    if (response.error) {
                        const { code } = response.error;
                        if (code === 401)
                            downloadLink.href = "/notAuthorized";
                        if (code === 404)
                            downloadLink.href = "/not-found";
                        downloadLink.target = '_blank';
                    } else {
                        const { data, contentType, fileName } = response.data;
                        const uint8Array = new Uint8Array(atob(data).split('').map(char => char.charCodeAt(0)));
                        const blob = new Blob([uint8Array], { type: contentType });
                        const webUrl = window.URL.createObjectURL(blob);

                        downloadLink.href = webUrl;
                        downloadLink.download = fileName;
                        downloadLink.target = '_self';

                        this.setState({ webUrl: webUrl });
                    }

                    downloadLink.click();
                },
                (e) => {
                    console.error(e)
                }
            )
        }
    }
}


export default DownloadFileButton;
